import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import React from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './DENTModalOverviewHeader.module.scss';

interface Props {
	title: string;
	onClose: () => void;
}

const DENTModalOverviewHeader = ({ title, onClose }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.header}>
			<div className={styles.title}>{t(title)}</div>
			<LinkButton
				title='base.shared.close'
				theme={Theme.RED}
				onClick={onClose}
			/>
		</div>
	);
};

export default DENTModalOverviewHeader;
